<!-- 首页的评论模块 -->
<template>
  <div class="module-comment home-module-space" v-if="comment.data && comment.data.length > 0">
    <div
      class="container"
      :class="{
        'container--wide': moduleConfig.wildscreen,
      }"
    >
      <!-- 滑块展示 -->
      <template v-if="moduleConfig.show_type === 'swiper'">
        <card-swiper
          :data="comment.data"
          :loading="loading"
          :module-config="moduleConfig"
          :avg-rating="comment.avgRating"
          @click="openModal"
        />
      </template>
      <!-- 瀑布流卡片展示 -->
      <template v-else>
        <col-card
          :data="comment.data"
          :loading="loading"
          :module-config="moduleConfig"
          :comment-config="commentConfig"
          :avg-rating="comment.avgRating"
          @openModal="openModal"
        />
      </template>
    </div>
    <!-- 弹窗 -->
    <v-comments-modal
      v-if="showModal"
      comment_mode="page"
      :comment="commentConfig"
      :comment_item="comment_item"
      :modal_index="modal_index"
      @change_modal_index="change_modal_index"
      @close="handleClose"
    ></v-comments-modal>
  </div>
</template>

<script>
import commentsUl_waterfallVue from '@/js/components/view/comments/commentsUl_waterfall.vue'
import commentModalVue from '@/js/components/view/comments/commentModal.vue'
import commentsstarVue from '@/js/components/view/comments/commentsstar.vue'
import ColCard from './ColCard.vue'
import CardSwiper from './CardSwiper.vue'

export default {
  name: 'vModuleComment',
  components: {
    vCommentsWaterfall: commentsUl_waterfallVue,
    vCommentsModal: commentModalVue,
    vCommentsStart: commentsstarVue,
    ColCard,
    CardSwiper,
  },
  props: {
    // 模块设置
    moduleConfig: {
      type: Object,
      default: {},
    },
    // 评论配置
    commentConfig: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      comment: {
        data: [],
        page: 1,
        pageSize: 20,
        total: 0,
        avgRating: 0, // 平均分
      },
      loading: false,
      error: null,
      modal_index: null,
      comment_item: {},
      customButtom: {
        show: this.moduleConfig?.show_custom_button?.show || false,
        text: this.moduleConfig?.show_custom_button?.text || null,
        url: this.moduleConfig?.show_custom_button?.url || null,
      },
      showModal: false,
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    // 获取博客数据
    // 全部返回
    async fetch(params = {}) {
      const { dispatch } = this.$store

      this.loading = true

      try {
        const res = await dispatch({
          type: 'comments/fetch',
          payload: {
            filter: {
              visible: true,
              approving: 'yes',
              product_comment_status: true,
              on_sale_product: true,
              gallery: this.moduleConfig.only_image_comment || undefined,
            },
            sort: '-comment_date',
            page: 1,
            page_size: this.moduleConfig.count,
            ...params,
          },
        })

        const { status, data } = res
        if (status === 200) {
          // 截取数据, 最后一页可能没有满
          const commentData = data?.data || []
          this.comment.data = commentData
          this.comment.total = data?.meta?.total || 0

          // 计算平均分
          if (commentData.length > 0) {
            let totalRating = 0
            commentData.forEach((item) => {
              const rating = parseInt(item.rating || 0, 10)
              totalRating += rating
            })

            this.comment.avgRating = totalRating / commentData.length
          }
        }
      } catch (err) {
        const { response } = err
        const data = response?.data
        this.err = data?.message
        // 错误消息弹窗
        if (data?.errors) {
          Vue.prototype.$message.error(Object.values(data.errors)[0]?.[0])
        } else if (data?.message) {
          Vue.prototype.$message.error(data.message)
        }
      }
      this.loading = false
    },
    /**
     * 打开弹窗，这块代码需要修改
     * 用不用jq操作dom
     * 传个index即可
     */
    openModal(index, item) {
      this.comment_item = this.comment.data?.[index]
      this.modal_index = 1
      this.showModal = true
      // 渲染弹窗会慢一拍，这里做个延迟
      setTimeout(() => {
        Jq('#commentModal').modal('show')
      }, 50)
    },
    change_modal_index(index) {
      this.modal_index = index
    },
    handleClose() {
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.module-comment {
  .container {
    overflow: hidden;
  }
}
</style>
